import { graphql } from "@/gql";

export const bookingCancelledByQuery = graphql(`
  query BookingCancelledBy($id: ID!) {
    booking(id: $id) {
      id
      cancelledByActivity {
        id
        created_at
        causer {
          id
          name
        }
      }
    }
  }
`);
